<template>
  <v-container fluid :class="$style['container']">
    <v-overlay :value="processing">
      <v-progress-circular indeterminate size="64"></v-progress-circular>
    </v-overlay>
    <ToolBar :class="$style['container-header']">
      <template v-slot:left>
        <Breadcrumb :items="breadcrumbs" />
      </template>
      <template v-slot:right>
        <fragment v-if="resourceName === 'products'">
          <div class="d-flex align-center">
            <v-btn
                    class="mx-1"
                    small
                    color="success"
                    max-height="36"
                    depressed
                    href="/templates"
                    target="_blank"
            >
              レビュー項目を編集
            </v-btn>
          </div>
          <div class="d-flex align-center">
            <v-btn
                    class="mx-1"
                    small
                    color="success"
                    max-height="36"
                    depressed
                    href="/message"
                    target="_blank"
            >
              自動返信設定
            </v-btn>
          </div>
        </fragment>
      </template>
    </ToolBar>
    <div :class="$style['container-content']">
      <v-content class="app-content">
        <div :class="$style['main-content']">
          <template v-if="error && resourceName !== 'administrators'">
            <div :class="$style['container-error']">
              <p>
                <v-icon color="red darken-2">mdi-alert-circle</v-icon>
                <span>エラーが発生しました</span>
              </p>
              <v-btn @click="onBack">戻る</v-btn>
            </div>
          </template>
          <template v-else>
            <MyForm :formKey="'base-form'" :entity="entity" :input="input" ref="form">
              <template v-for="(field, index) in fields">
                <FieldGenerator
                  v-model="input[field.name]"
                  :key="index"
                  :type="field.type"
                  :name="field.name"
                  :label="field.label"
                  :optionType="field.optionType"
                  :selects="field.selects"
                  :checkedIds="field.checkedIds"
                  :textKey="field.textKey"
                  :valueKey="field.valueKey"
                  :multiple="field.multiple"
                  :limit="field.limit"
                  :rules="field.rules"
                  :width="field.width"
                  :show="show(field.name)"
                  :placeholder="field.placeholder"
                  :remarks="field.remarks"
                  :column="field.column"
                  :accept="field.accept"
                  :render="field.render || undefined"
                  :unit="field.unit"
                  :conditionError="conditionError"
                  v-if="isShowField(field)"
                >
                  <template v-if="field.type === 'custom'" :slot="field.name">
                    <fragment v-if="field.name === 'images' && resourceName === 'products'">
                      <ValidationProvider v-slot="{ errors }" rules="required" name="メイン画像" vid="image_main">
                      <v-radio-group v-model="input['image_main']" name="image_main">
                        <ImageList
                                :input.sync="input[field.name]"
                                :resourceName="resourceName"
                                mode="edit"
                                :required="true"
                                :imageMain="true">
                          <template slot="image_main" slot-scope="{ input }">
                            <v-radio color="primary" class="ma-2" :value="imageFileName(input)" label="メイン画像"/>
                          </template>
                        </ImageList>
                        <div v-if="errors" class="invalid-feedback" style="display: inline">{{errors[0]}}</div>
                      </v-radio-group>
                      </ValidationProvider>
                    </fragment>
                    <fragment v-else-if="field.name === 'publish_at'">
                      <DatetimeField
                        v-model.sync="input[field.name]"
                        name="publish_at"
                        label="お知らせ公開(予定)日時"
                        :rules="field.rules"
                        :timePicker="true"
                        width="250px"
                      />
                    </fragment>
                    <fragment v-else-if="field.name === 'sample_quantity'">
                      <TextField
                        v-model.sync="input[field.name]"
                        name="sample_quantity"
                        label="サンプル出荷単位"
                        rules="max:255"
                        :placeholder="field.placeholder"
                      />
                    </fragment>
                    <fragment v-else-if="field.name === 'description'">
                      <TextareaField
                        v-model.sync="input[field.name]"
                        name="description"
                        label="概要"
                        rules="max:255"
                        :largeHeight="true"
                      />
                    </fragment>
                    <fragment v-else-if="field.name === 'additional_comments'">
                      <TextareaField
                        v-model.sync="input[field.name]"
                        name="additional_comments"
                        label="フリー欄"
                        :largeHeight="true"
                      />
                    </fragment>
                    <fragment v-else>
                      <slot
                              :name="field.name"
                              :input.sync="input[field.name]"
                              :error-messages="errorMessages[field.name]"
                      />
                    </fragment>
                  </template>
                </FieldGenerator>
                <v-flex v-if="field.name === 'allergens'" xs12 :class="$style['comment']">
                  <span>
                    ※アレルギーのない場合は、「なし」と記入してください
                  </span>
                </v-flex>
                <v-flex v-if="field.name === 'sample_quantity' && isShowField(field)" xs12 :class="$style['comment']">
                     <span>
                       ※ユーザーから依頼があった際に出荷できるサンプルの量
                     </span>
                </v-flex>
              </template>
            </MyForm>
          </template>
        </div>
        <div v-if="!error || resourceName === 'administrators'" :class="$style['container-footer']">
          <v-toolbar>
            <CButton class="mx-1" color="primary" @click="onCreate">
              登録
            </CButton>
            <CButton class="mx-1" color="info" @click="onBack">
              キャンセル
            </CButton>
          </v-toolbar>
        </div>
      </v-content>
    </div>
  </v-container>
</template>

<script>
import MyForm from "@/components/form";
import FieldGenerator from "@/components/field/generator";
import ToolBar from "@/components/app/toolbar";
import Breadcrumb from "@/components/app/breadcrumb";
import RadioField from '../../components/field/radio';
import TextField from '../../components/field/text';
import TextareaField from '../../components/field/textarea';
import ImageList from '../../components/field/images-list';
import DatetimeField from '../../components/field/datetime';

export default {
  components: {
    MyForm,
    FieldGenerator,
    ToolBar,
    Breadcrumb,
    RadioField,
    TextField,
    TextareaField,
    ImageList,
    DatetimeField
  },
  props: {
    resourceName: {
      type: String,
      required: true
    },
    fields: {
      type: Array,
      required: true
    },
    breadcrumbs: {
      type: Array,
      default: () => []
    }
  },
  data() {
    return {
      input: {},
      providingSamplesFlg: false,
      conditionError: false
    };
  },
  watch: {
    "input.questionnaire_id": {
      handler(value) {
        this.$store.getters[`common/questionnaires/options/options`].some(option => {
          if (option.value === value) {
            this.input.questionnaire_url = option.url;
          }
        });
        this.$store.getters[`common/reminder_templates/options/options`].some(option => {
          if (option.value === this.input.reminder_template_id) {
            this.input.title = option.label === '---' ? "" : option.label;
            this.input.body = option.body.replace('<URL>', this.input['questionnaire_url'] + '<userId>');
            return true;
          }
        });
      }
    },
    "input.questionnaire_url": {
      handler(value) {
        this.$store.getters[`common/reminder_templates/options/options`].some(option => {
          if (option.value === this.input.reminder_template_id) {
            this.input.title = option.label === '---' ? "" : option.label;
            this.input.body = option.body.replace('<URL>', this.input['questionnaire_url'] + '<userId>');
            return true;
          }
        });
      },
      deep: true
    },
    "input.maker_id": {
      handler(value) {
        if (this.resourceName === "recipes" && this.input.maker_id !== null) {
          // メーカーを指定した商品リストを取得する
          this.$store.dispatch(`common/products/options/index`, {maker_id: this.input.maker_id});
        }
      }
    },
    "input.large_category_id": {
      handler(value) {
        if (this.resourceName === "products" && this.input.large_category_id !== null) {
          this.$store.dispatch(
            `common/product_medium_categories/options/index`,
            this.input.large_category_id
          );
        }
      }
    },
    "input.providing_samples": {
      handler(value) {
        if (this.resourceName === "products") {
          if (value) {
            this.providingSamplesFlg = true;
          } else {
            this.providingSamplesFlg = false;
            this.input.sample_quantity = null;
          }
        }
      }
    },
    "input": {
      handler(value) {
        if (this.resourceName === 'templates') {
          this.$store.dispatch(`templates/entity/updateSelectedItems`, { value: value });
        }
      },
      deep: true
    },
    "input.notification_type": {
      handler(value) {
        if (this.resourceName === "reminders") {
          this.$store.dispatch(
            `common/reminder_templates/options/index`,
            this.input.notification_type
          ).then(() => {
            if (this.input.notification_type === 2) {
              this.$set(this.input, 'reminder_template_id', 1)
            } else {
              this.$set(this.input, 'reminder_template_id', 2)
            }
          });
        }
      }
    },
    "input.reminder_template_id": {
      handler(value) {
        this.$store.getters[`common/reminder_templates/options/options`].some(option => {
          if (option.value === value) {
            this.input.title = option.label === '---' ? "" : option.label;
            this.input.body = option.body.replace('<URL>', this.input['questionnaire_url'] + '<userId>');
            return true;
          }
        });
      }
    }
  },
  computed: {
    entity() {
      return this.$store.getters[`${this.resourceName}/entity/entity`];
    },
    processing() {
      return this.$store.getters[`${this.resourceName}/entity/isProcessing`];
    },
    error() {
      return this.$store.getters[`${this.resourceName}/entity/error`];
    },
    errorMessages() {
      return (
        this.$store.getters[`${this.resourceName}/entity/errorMessages`] || []
      );
    },
    show() {
      return name => {
        return true;
      };
    },
    isProvider() {
      return this.$store.getters[`auth/isProvider`];
    }
  },
  methods: {
    onCreate() {
      if (!this.$refs.form) {
        return;
      }

      this.$refs.form.validate().then(success => {
        if (!success) {
          return;
        }
        
        if(this.resourceName === 'reminders'){
          if(!(this.input.conditions && (this.input.conditions['user_type'] != null || this.input.conditions['sex'] != null || this.input.conditions['birth_date'] != null || this.input.conditions['large_location'] != null
            || this.input.conditions['medium_location'] != null || this.input.conditions['biz_large_category'] != null || this.input.conditions['biz_medium_category'] != null || this.input.conditions['business_scale'] != null
            || this.input.conditions['business_area'] != null || this.input.conditions['lunch_menu'] != null || this.input.conditions['plan_num'] != null || this.input.conditions['logged_in_at'] != null
            || this.input.conditions['user_ids'] != null)))
          {
            this.conditionError = true;
            return;
          }else{
            this.conditionError = false;
          }
        }

        // テキストリスト対応
        if (this.resourceName === 'recipes') {
          let returnFlg = true;
          this.input.procedure.forEach(procedure => {
            if (procedure){
              returnFlg = false;
            }
          });
          if (returnFlg) {
            return;
          }

          if(this.input.keywords.length > 1) {
            let s = new Set(this.input.keywords);
            if(s.size !== this.input.keywords.length){
              return;
            }
          }
        }
        if (this.resourceName === 'products') {
          let returnFlg = true;
          this.input.allergens.forEach(allergen => {
            if (allergen){
              returnFlg = false;
            }
          });
          if (returnFlg) {
            return;
          }
        }

        this.$store
          .dispatch(`${this.resourceName}/entity/store`, {
            storedEntity: this.input
          })
          .then(() => {
            this.$router.push({ name: this.resourceName });
          })
          .catch(() => {
            if (this.$refs.form) {
              this.$refs.form.setErrors(this.errorMessages);
            }
          });
      });
    },
    onBack() {
      this.$store.commit(`${this.resourceName}/entity/initialize`);
      this.$router.push({ path: `/${this.resourceName}` });
    },
    initialize() {
      this.$store.commit(`${this.resourceName}/entity/initialize`);

      this.input = {
        ...JSON.parse(
          JSON.stringify(
            this.$store.getters[`${this.resourceName}/entity/initialEntity`]
          )
        )
      };
    },
    isShowField(field){
      if(field.name === 'sample_quantity' && !this.providingSamplesFlg){
        return false;
      }

      if(
        (field.name === 'permission_maker' || field.name === 'permission_user' || field.name === 'permission_article' )
        && this.input['permission_all'] === 1){
        return false;
      }

      if (['questionnaire_id', 'questionnaire_url'].indexOf(field.name) !== -1 && this.input['notification_type'] !== 2) {
        return false;
      }

      if (['product_id', 'review_id'].indexOf(field.name) !== -1 && this.input['notification_type'] !== 3) {
        return false;
      }

      if(field.name === 'reminder_template_id'){
        if (this.input['notification_type'] === 3) {
          return true;
        }
        if (this.input['notification_type'] === 2 && this.input['questionnaire_id']) {
          return true;
        }
        return false;
      }

      return true;
    },
    imageFileName(image) {
      if (typeof (image) !== 'string' && !(image instanceof String)) {
        if (this.input['images'].length === 1) {
          this.input['image_main'] = image['fileName'];
        }
        return image['fileName'];
      }
      if (this.input['images'].length === 1) {
        this.input['image_main'] = image;
      }
      return image;
    }
  },
  created() {
    this.initialize();
  }
};
</script>

<style module lang="scss">
$base-app-header-height: 75px;
$base-header-height: 55px;
$base-footer-height: 60px;

.container.container {
  width: 100%;
  height: calc(100% - #{$base-app-header-height});
  padding: 0;

  .container-header {
    height: $base-header-height !important;
  }

  .container-content {
    display: flex;
    flex-direction: row;
    justify-content: flex-start;
    height: calc(100% - #{$base-header-height});
    overflow: hidden;

    .main-content {
      height: calc(
        100vh - #{$base-header-height} - #{$base-footer-height}
      );
      padding: 8px;
      overflow-y: auto;
      overflow-x: hidden;
    }

    .container-error {
      position: absolute;
      top: 50%;
      left: 50%;
      transform: translate(-50%, -50%);
      text-align: center;
      p {
        color: #ff0000;
        i {
          margin: 0 10px 0 0;
        }
        i,
        span {
          vertical-align: middle;
        }
      }
    }
  }

  .container-footer {
    height: $base-footer-height !important;
  }
}

.comment {
  padding: 0 16px;
  margin-bottom: 10px;
}
</style>
